import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getFullAttachmentUrl } from '@services/api/index.js'

const TalentCard = ({ talent, onContact }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleViewDetail = () => {
    // 将人才数据存储到sessionStorage中
    sessionStorage.setItem('selectedTalent', JSON.stringify(talent));
    navigate(`/talents/${talent.talentId}`);
  };

  // 从data字段中获取人才信息
  const talentData = talent?.data || {};

  return (
    <div 
      className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-all duration-200 hover:border-primary-300 cursor-pointer"
      onClick={handleViewDetail}
    >
      {/* 头像 */}
      <div className="flex justify-center mb-4">
        <img
          src={getFullAttachmentUrl(talent?.imageId) || '/images/default-avatar.svg'}
          alt={talentData.name || '人才头像'}
          className="w-20 h-20 rounded-full object-cover border-2 border-gray-100"
          onError={(e) => {
            e.target.src = '/images/default-avatar.svg';
          }}
        />
      </div>

      {/* 基本信息 */}
      <div className="text-center mb-3">
        <h3 className="text-lg font-semibold text-gray-900 mb-1">
          {talentData.name || '未知'}
        </h3>
        <p className="text-sm text-gray-600 mb-2">
          {talentData.occupation || '未指定职业'}
        </p>

        {/* 国家 */}
        <p className="text-xs text-gray-500 mb-2 flex items-center justify-center">
          <span className="mr-1">📍</span>
          {talentData.country || '未指定国家'}
        </p>
      </div>

      {/* 操作按钮 */}
      <div className="flex justify-center">
        <button
          onClick={handleViewDetail}
          className="text-xs px-3 py-1 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors duration-200"
        >
          {t('talents.card.viewProfile')}
        </button>
      </div>
    </div>
  );
};

export default TalentCard; 